(function($, root, undefined) {

    $(function() {
        $('.configurator__col').matchHeight();

        $('.configurator__item').on('click', function(e) {
            e.preventDefault();
            $('.configurator__item').removeClass('configurator__item--active');
            $('.configurator__listitem a').removeClass('is-active');

            $(this).addClass('configurator__item--active');

            sector_type = $(this).attr('data-attr-sector-type');

            $('.configurator__col__services').removeClass('configurator__col--active');

            $('.configurator__col__sector').removeClass('configurator__col--active').addClass('configurator__col--inactive');
            $('.configurator__col--' + sector_type).removeClass('configurator__col--inactive').addClass('configurator__col--active');

        });

        $('.configurator__listitem a').click(function() {

            $('.configurator__listitem a').removeClass('is-active');
            $(this).addClass('is-active');

            children = $(this).attr('data-attr-children');

            if (children == '0') {
                return true;
            }

            post_id = $(this).attr('data-attr-item');
            term = $(this).attr('data-attr-term');

            $('.configurator__loader').show();

            $.ajax({
                url: admin_ajax.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'action': 'get_configurator_services_from_sector_id',
                    'data': {
                        'id': post_id,
                        'term': term
                    }
                },
                success: function(data) {

                    //add result

                    $('.configurator__col__services .configurator__list').empty();

                    $('.configurator__col__services .configurator__list').append(data.result);

                    $('.configurator__col__services').addClass('configurator__col--active').removeClass('configurator__col--inactive');

                    $('.configurator__loader').hide();

                    $('.configurator__col__services').outerHeight($('.configurator__col__sector').outerHeight());

                }
            });

            return false;

        });

    });

})(jQuery, this);